import { Injectable } from '@angular/core';
import html2canvas from "html2canvas";

export interface NcHtml2canvasOptions {
  type?: 'canvas' | 'base64' | 'blob';// 输出图片的类型
  scale?: number;// 输出图片的缩放比例
  backgroundColor?: string;// 输出图片的背景颜色
}

@Injectable()
export class NcHtml2canvasService {

  constructor() { }

  /**
   * 截图
   * @param dom 要截图的DOM元素
   * @param options 截图配置
   * @param options.type 输出图片的类型，可选值：'canvas' | 'base64' | 'blob'，默认值：'canvas'
   * @param options.scale 输出图片的缩放比例，值越大清晰度越高，默认值：1
   * @param options.backgroundColor 输出图片的背景颜色，默认值：'white'
   * @returns 根据type返回不同类型：
   *          - 'canvas': 返回 HTMLCanvasElement
   *          - 'base64': 返回 base64 字符串
   *          - 'blob': 返回 Blob 对象
   */
  async html2canvas(dom: HTMLElement, options?: NcHtml2canvasOptions) {
    return new Promise<any>(async (resolve, reject) => {
      // 手动创建一个 canvas 标签
      const canvas = document.createElement("canvas")
      //屏幕缩放比
      const screenScale = this.getScreenScale();
      // 获取父级的宽高
      const width = parseInt(getComputedStyle(dom).width) * screenScale;
      const height = parseInt(getComputedStyle(dom).height) * screenScale;
      //画布缩放比例
      const baseScale = options?.scale || 1;
      //画布实际宽高（像素）
      canvas.width = width * baseScale;
      canvas.height = height * baseScale;
      //生成画笔
      const ctx: any = canvas.getContext("2d");
      //设置绘图上下文的缩放比例，确保绘制的内容与 canvas 的实际尺寸匹配。
      ctx.scale(baseScale, baseScale);
      //画布在页面上显示的宽高
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';

      // 假如dom宽高400*400,baseScale=2时,canvas的实际宽高为800*800
      // 但是返回的canvas的style宽高为400*400
      // 这样可以提高清晰度，baseScale越大，清晰度越高，文件越大

      const config: any = {
        backgroundColor: options?.backgroundColor || 'white',
        canvas: canvas,
        useCORS: true
      }
      const data: HTMLCanvasElement = await html2canvas(dom, config);
      const type = options?.type || 'canvas';
      if (type == 'blob') {
        data.toBlob((blob: Blob | null) => {
          resolve(blob);
        })
      } else if (type == 'base64') {
        resolve(data.toDataURL("image/png"));
      } else {
        resolve(data);
      }
    });
  }

  // 获取屏幕缩放比例方法
  private getScreenScale() {
    var screenScale = 1;
    var screen: any = window.screen;
    var ua = navigator.userAgent.toLowerCase();
    //设备像素比
    if (window.devicePixelRatio !== undefined) {
      screenScale = window.devicePixelRatio;
      //IE11以下版本浏览器
    } else if (ua.indexOf('msie') > -1) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
        screenScale = screen.deviceXDPI / screen.logicalXDPI;
      }
      //浏览器自身缩放
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      screenScale = window.outerWidth / window.innerWidth;
    }
    if (screenScale) {
      screenScale = Math.round(screenScale * 100) / 100;
    }
    return screenScale;
  }
}

